var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Field } from 'react-final-form';
import { P } from '@tpr/core';
import { RadioButtonChecked, RadioButtonUnchecked } from './icons';
import { StyledInputLabel } from '../elements';
import { HiddenInput } from '../hidden/hidden';
import styles from './radio.module.scss';
import AccessibilityHelper from '../accessibilityHelper';
export var RadioButton = function (_a) {
    var id = _a.id, cfg = _a.cfg, _b = _a.disabled, disabled = _b === void 0 ? false : _b, testId = _a.testId, name = _a.name, checked = _a.checked, onChange = _a.onChange, label = _a.label, value = _a.value, hint = _a.hint, className = _a.className, _c = _a.required, required = _c === void 0 ? false : _c;
    var msg = testId ? testId + "-" + (checked ? 'checked' : 'unchecked') : null;
    var helper = new AccessibilityHelper(id ? id : name + "_" + value, !!label, !!hint);
    return (React.createElement(StyledInputLabel, { element: "div", className: className, cfg: Object.assign({
            mt: 1,
            mb: 1,
            py: 1,
        }, cfg) },
        React.createElement("label", { id: helper && helper.labelId, className: styles.wrapper + " " + (disabled ? styles.disabled : ''), "data-testid": msg, htmlFor: id },
            React.createElement("div", { className: styles.innerWrapper },
                React.createElement(HiddenInput, { type: "radio", id: id, name: name, checked: checked, value: value, disabled: disabled, required: required, onChange: onChange, "data-testid": testId }),
                checked ? (React.createElement(RadioButtonChecked, { className: styles.radio })) : (React.createElement(RadioButtonUnchecked, { className: styles.radio })),
                React.createElement(P, { cfg: { fontWeight: 3 }, className: styles.label }, label)),
            hint && (React.createElement(P, { id: helper && helper.hintId, className: styles.hint }, hint)))));
};
export var FFRadioButton = function (fieldProps) {
    var handleChange = function (input, value) {
        input.onChange(value);
        fieldProps.callback && fieldProps.callback(value);
    };
    return (React.createElement(Field, __assign({}, fieldProps, { type: "radio", render: function (_a) {
            var label = _a.label, input = _a.input, rest = __rest(_a, ["label", "input"]);
            return (React.createElement(RadioButton, __assign({ name: input.name, value: input.value, checked: input.checked, label: label, onChange: function (e) { return handleChange(input, e.target.value); } }, rest)));
        } })));
};
//# sourceMappingURL=radio.js.map